(function () {
    'use strict';

    angular
        .module('commons')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('commons', {
                url: '/commons',
                templateUrl: 'commons/views/commons.tpl.html',
                controller: 'CommonsCtrl',
                controllerAs: 'commons'
            });
    }
}());
